/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CREATE_POLICY: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.BuyInsurancePage.createInsurance',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CREATE_ORDER' },
      },
    },
    CREATE_ORDER: {
      invoke: {
        id: 'createOrder',
        src: 'createOrder',
        onDone: {
          target: 'TRIGGER_FIAT_PURCHASE',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_POLICY_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    TRIGGER_FIAT_PURCHASE: {
      invoke: {
        id: 'triggerFiatPurchase',
        src: 'triggerFiatPurchase',
        onDone: {
          target: 'WAITING_FOR_FIAT_CALLBACK',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_POLICY_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    WAITING_FOR_FIAT_CALLBACK: {
      invoke: {
        id: 'waitingForCallback',
        src: 'waitingForCallback',
        onDone: {
          target: 'CREATE_POLICY_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_POLICY_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    // CREATE_POLICY: {
    //   invoke: {
    //     id: 'createPolicy',
    //     src: 'createPolicy',
    //     onDone: {
    //       target: 'CREATE_POLICY_SUCCESS',
    //       actions: ['successAction'],
    //     },
    //     onError: {
    //       target: 'CREATE_POLICY_FAILED',
    //       actions: ['failureAction'],
    //     },
    //   },
    // },
    CREATE_POLICY_SUCCESS: {
      type: 'final',
    },
    CREATE_POLICY_FAILED: {
      on: {
        START: { target: 'CREATE_ORDER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
